import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { ClaimOrderListPage } from "@/modules/order";
import { requireAuthAndPermission } from "@/utils";

const claimOrderSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1)
});

export const Route = createFileRoute("/disbursement/claim-orders/")({
  validateSearch: zodValidator(claimOrderSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Claim Orders"
        description="Review and process external payment claim orders."
      />
      <ClaimOrderListPage />
    </>
  )
});

export type ClaimOrderSearchSchema = z.infer<typeof claimOrderSearchSchema>;
